// extracted by mini-css-extract-plugin
export default {"container":"TrxvyPky","searchWrapper":"LxiVSerr","collapseWrapper":"vRUS6zfO","groupLabel":"Vt_6o60U","emptyText":"pPGSObH7"};